export default __webpack_public_path__ + "static/media/02.e5b47e42.png";